'use client';

import * as React from 'react';
import { useLocalStorageValue } from '@react-hookz/web';
import { ClientOnly } from 'components/client-only';
import { Separator, Skeleton, SubmitButton } from 'ui';
import { SettingSwitch } from '../../site/[subdomain]/_components/setting-switch';

export const CHAT_WIDGET_DISABLED_KEY = 'chat-widget-disabled';

export function GeneralSettings({ isEU }: { isEU: boolean }): JSX.Element {
  const { value: isChatDisabled, set: setIsChatDisabled } =
    useLocalStorageValue(CHAT_WIDGET_DISABLED_KEY, {
      defaultValue: false,
      initializeWithValue: true,
    });
  function handleSave(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    window.location.reload();
  }
  return (
    <form className="w-full flex-1 rounded-md border" onSubmit={handleSave}>
      <div className="px-6 py-8">
        <div className="space-y-4">
          {/* Somehow switch doesn't work with SSR */}
          <ClientOnly
            fallback={
              <div className="space-y-1">
                <Skeleton className="h-5" />
                <Skeleton className="h-5" />
              </div>
            }
          >
            <SettingSwitch
              checked={!isChatDisabled}
              onCheckedChange={(checked) => setIsChatDisabled(!checked)}
              label="Show Chat Widget"
              name="disableChatWidget"
              hint={
                <>
                  <span className="hidden xs:inline">
                    Enable or disable the in-app chat support widget
                    {isEU && <>{", disabled if you don't accept cookies."}</>}
                  </span>
                  <span className="inline xs:hidden">
                    Chat widget is disabled on mobile
                  </span>
                </>
              }
            />
          </ClientOnly>
        </div>
      </div>
      <Separator />
      <footer className="flex justify-end rounded-b-md bg-gray-50 px-6 py-4">
        <SubmitButton>Save</SubmitButton>
      </footer>
    </form>
  );
}
